"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTaxonomyCardValues = exports.EntityTaxonomyCardValuesDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var entity_list_1 = require("./entity-list");
var use_entities_1 = require("../../hooks/use-entities");
var lodash_1 = require("lodash");
var use_active_person_1 = require("../../hooks/use-active-person");
var cls = (0, cn_1.classNames)('taxonomy-entity-card-links');
exports.EntityTaxonomyCardValuesDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n    padding-top: ", ";\n    ", "\n  "], ["\n    margin-top: ", ";\n    padding-top: ", ";\n    ", "\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG())
});
var TaxonomiesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Taxonomies: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), TaxonomiesStyles)
};
var EntityTaxonomyCardValues = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var entities = (0, use_entities_1.useEntities)();
  var user = (0, use_active_person_1.useActivePerson)();
  var _a = entity.trends,
    trends = _a === void 0 ? [] : _a,
    _b = entity.topics,
    topics = _b === void 0 ? [] : _b,
    _c = entity.subTopics,
    subTopics = _c === void 0 ? [] : _c,
    _d = entity.challenges,
    challenges = _d === void 0 ? [] : _d,
    _e = entity.keyIssues,
    keyIssues = _e === void 0 ? [] : _e;
  var items = (0, lodash_1.flatten)((0, lodash_1.filter)([entities.Challenge && challenges, entities.KeyIssue && keyIssues, entities.Trend && trends, entities.Topic && topics, entities.SubTopic && subTopics]));
  if (!items.length) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Taxonomies, {
    variant: 'card',
    items: items
  }));
};
exports.EntityTaxonomyCardValues = EntityTaxonomyCardValues;
exports.EntityTaxonomyCardValues.cls = cls;
exports.EntityTaxonomyCardValues.defaultProps = exports.EntityTaxonomyCardValuesDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;